import styled from 'styled-components';

const DetailsWrapper = styled.div`
  max-width: 670px;
  margin: 0 auto;  
  .section {
    background-color: ${p => p.theme.color.bg_white};
    transition: all .25s .25s ease-in-out;
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: 1px solid ${p => p.theme.color.border};
    &:last-of-type {
      border-bottom: none;
    }
    >*:last-child {
      margin-bottom: 1em
    }  
  }  

  .input-label {
    color: ${p => p.theme.color.label};
    font-size: .85em;
    display: block;
    margin: 0;
  }

  .select-field-wrapper {
    margin-top: .5em;
    .input-label {
      margin-bottom: .35em;
    }
  }

  .day-range-wrapper {
    justify-content: flex-start;
    margin-top: 1em;
    >div {
      margin-right: .8em;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

export default { DetailsWrapper };